import type { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import type { ProfileResponse } from '@masha/shared';

interface Props {
  /** true: разрешает рендер только если онбординг пройден; иначе редирект на /onboarding */
  requireOnboarded?: boolean;
  /** true: разрешает рендер только если онбординг НЕ пройден; иначе редирект на / */
  requireNotOnboarded?: boolean;
}

export function RedirectByOnboarding({
  requireOnboarded,
  requireNotOnboarded,
  children,
}: PropsWithChildren<Props>) {
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'] });

  if (!data) {
    return null;
  }

  const isOnboarded = data.user.onboardedAt !== null;

  if (requireOnboarded && !isOnboarded) {
    return <Navigate to="/onboarding" replace />;
  }
  if (requireNotOnboarded && isOnboarded) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
